import React from 'react';
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import ErrorMessage from './ErrorMessage';


const AddBankAccount = ({show, action: {action, error, actedOn, data}, onHide}) => {

    return <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header >
              <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")}
                    />
                </span> {action}
              </Modal.Title>
              <button type="button" className="close" onClick={onHide}>
                  <span aria-hidden="true" className="d-block">×</span>
                  <span className="sr-only">Close</span>
               </button>
            </Modal.Header>
            <Modal.Body>
                <ErrorMessage {...{error}} />
                <div className="px-md-5">
                    <div className="row">
                        <div className="col-md-5 h6">
                            User
                        </div>
                        <div className="col-md h6 text-muted">
                            <NavLink to={`/users/view/${data?.userId}`} target="_blank" >
                                {`${data.meta?.firstName ?? ""} ${data.meta?.lastName ?? ""}`}
                            </NavLink>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Email
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.email}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Bank Name
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.bankName}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Account Number
                        </div>
                        <div className="col-md h6 text-muted">
                            ******{data.accountNumber?.substr(-4)}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Account Name
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.accountName}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Currency
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.currency}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-5 h6">
                            Account Type
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.accountType}
                        </div>
                    </div>

                    <div className={`${data?.currency?.toUpperCase() !== "NGN" ? "" : "d-none"}`}>                        
                        <div className="row mt-4">
                            <div className="col-md-5 h6">
                                Bank Address
                            </div>
                            <div className="col-md h6 text-muted">
                                {data?.bankAddress}
                            </div>
                        </div>                        
                        <div className="row mt-4">
                            <div className="col-md-5 h6">
                                Bank City
                            </div>
                            <div className="col-md h6 text-muted">
                                {data?.bankCity}
                            </div>
                        </div>                        
                        <div className="row mt-4">
                            <div className="col-md-5 h6">
                                Bank Country Code
                            </div>
                            <div className="col-md h6 text-muted">
                                {data?.bankCountryCode}
                            </div>
                        </div>                        
                        <div className="row mt-4">
                            <div className="col-md-5 h6">
                                Bank Zip Code
                            </div>
                            <div className="col-md h6 text-muted">
                                {data?.bankZipCode}
                            </div>
                        </div>                        
                        <div className="row mt-4">
                            <div className="col-md-5 h6">
                                Bank Province
                            </div>
                            <div className="col-md h6 text-muted">
                                {data?.bankProvince}
                            </div>
                        </div>                        
                        <div className="row mt-4">
                            <div className="col-md-5 h6">
                                Swift or Aba
                            </div>
                            <div className="col-md h6 text-muted">
                                {data?.swiftAba}
                            </div>
                        </div>
                    </div>
                    
                </div>    
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
          </Modal>
}

export default AddBankAccount;